var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPitstop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2264_20418)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 1.49321H18C18.1326 1.49321 18.2598 1.54565 18.3536 1.639C18.4473 1.73234 18.5 1.85894 18.5 1.99095V12.9412C18.5 13.0732 18.4473 13.1998 18.3536 13.2931C18.2598 13.3865 18.1326 13.4389 18 13.4389H14.889C15 13.9286 15.0284 14.4332 14.973 14.9321H18C18.5304 14.9321 19.0391 14.7224 19.4142 14.349C19.7893 13.9756 20 13.4692 20 12.9412V1.99095C20 1.46292 19.7893 0.956511 19.4142 0.583136C19.0391 0.20976 18.5304 0 18 0H2C1.46957 0 0.960859 0.20976 0.585786 0.583136C0.210714 0.956511 0 1.46292 0 1.99095V12.9412C0 13.4692 0.210714 13.9756 0.585786 14.349C0.960859 14.7224 1.46957 14.9321 2 14.9321H6.027C5.97165 14.4332 6.00004 13.9286 6.111 13.4389H2C1.86739 13.4389 1.74021 13.3865 1.64645 13.2931C1.55268 13.1998 1.5 13.0732 1.5 12.9412V1.99095C1.5 1.85894 1.55268 1.73234 1.64645 1.639C1.74021 1.54565 1.86739 1.49321 2 1.49321ZM13 14.4344C13 14.9266 12.8534 15.4078 12.5787 15.817C12.304 16.2263 11.9135 16.5453 11.4567 16.7336C10.9999 16.922 10.4972 16.9713 10.0123 16.8753C9.52732 16.7792 9.08186 16.5422 8.73223 16.1942C8.3826 15.8461 8.1445 15.4027 8.04804 14.9199C7.95157 14.4372 8.00108 13.9368 8.1903 13.482C8.37952 13.0273 8.69995 12.6386 9.11107 12.3651C9.5222 12.0917 10.0055 11.9457 10.5 11.9457C11.163 11.9457 11.7989 12.2079 12.2678 12.6746C12.7366 13.1413 13 13.7743 13 14.4344ZM8.369 2.98643H6.684V7.70199H5L7.527 10.5321L10.053 7.70299H8.369V2.98643ZM13.316 10.5321V5.81557H15L12.474 2.98643L9.947 5.81557H11.631V10.5321H13.316Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2264_20418"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 16.9231,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPitstop);
export default __webpack_public_path__ + "static/media/pitstop.e45989b1b0f09940f24221ff28059e8b.svg";
export { ForwardRef as ReactComponent };